import { createSelector } from '@reduxjs/toolkit';

import type { CardTypeEnum } from 'components/domains/payments/Card';

import type { AppState } from 'redux-store';

const paymentMethodsSelector = (
  state: AppState,
): AppState['paymentsMethods']['paymentsMethods'] =>
  state.paymentsMethods.paymentsMethods;
  
export const getMobilePaymentSelector = (
  state: AppState,
): AppState['mobilePayment'] => state.mobilePayment;

export const isVisibleSelector = createSelector(
  getMobilePaymentSelector,
  ({ isVisible }) => isVisible,
);
export const stateSelector = createSelector(
  getMobilePaymentSelector,
  ({ state }) => state,
);
export const walletCardSelector = createSelector(
  getMobilePaymentSelector,
  ({ walletCardId }) => walletCardId,
);
export const productSelector = createSelector(
  getMobilePaymentSelector,
  ({ product }) => product,
);
export const walletCardIdSelector = createSelector(
  getMobilePaymentSelector,
  ({ walletCardId }) => walletCardId,
);
export const walletCardsSelector = createSelector(
  paymentMethodsSelector,
  cards =>
    cards.map(card => ({
      type: card.card.brand as CardTypeEnum,
      id: card.id,
      number: card.card.last4,
      expire: `${card.card.exp_month}/${card.card.exp_year}`,
    })),
);
export const paymentTypeSelector = createSelector(
  getMobilePaymentSelector,
  ({ paymentType }) => paymentType,
);
export const isLoadingCardSelector = createSelector(
  getMobilePaymentSelector,
  ({ isLoadingCard }) => isLoadingCard,
);
export const isLoadingButtonSelector = createSelector(
  getMobilePaymentSelector,
  ({ isLoadingButton }) => isLoadingButton,
);
export const isProcessingSelector = createSelector(
  getMobilePaymentSelector,
  ({ isProcessing }) => isProcessing,
);
export const modalTypeSelector = createSelector(
  getMobilePaymentSelector,
  ({ modalType }) => modalType,
);
export const statusSelector = createSelector(
  getMobilePaymentSelector,
  ({ status }) => status,
);
